import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} Address
 * @property {string} id
 * @property {string} full_name
 * @property {string} company_name
 * @property {string} address_line_1
 * @property {string} address_line_2
 * @property {string} city
 * @property {string} region
 * @property {string} zip_code
 * @property {string} country
 * @property {string} phone_number
 * @property {string} address_residential_indicator
 * @property {Array} address_errors
 */

/**
 * @typedef {Object} AddressesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Address[]} data
 */

export const ADDRESSES_ACTIONS = {
  SET_ADDRESSES: 'SET_ADDRESSES',
  UPDATE_ADDRESS: 'UPDATE_ADDRESS',
  SET_STATUS: 'SET_ADDRESSES_STATUS',
  SET_ERRORS: 'SET_ADDRESSES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_ADDRESSES_ERRORS'
}

export const initialAddressesState = {
  status: 'idle',
  errors: [],
  data: []
}

export const addressesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      full_name: PropTypes.string,
      company_name: PropTypes.string,
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      city: PropTypes.string,
      region: PropTypes.string,
      zip_code: PropTypes.string,
      country: PropTypes.string,
      phone_number: PropTypes.string,
      address_residential_indicator: PropTypes.string,
      address_errors: PropTypes.array
    })
  )
}
